const enabled = (value) => String(value || "").trim().toLowerCase() === "true";

export const FEATURES = Object.freeze({
  jobApplications: enabled(process.env.REACT_APP_ENABLE_JOB_APPLICATIONS),
});
